import { useTranslation } from 'react-i18next'
import { Box, Skeleton, Text } from '@machobear/design-system'
import { DetailsButtons } from './details-buttons'
import { PublicLinkField } from '../../../components/public-link-field'
import { useListingData } from '../../../context/listing-data'
import { CoverImage } from '../../../components/cover-image'

export const ListingDetailsCard = () => {
  const { t } = useTranslation()
  const { loading } = useListingData()

  return (
    <Box
      padding="gutter"
      background="white"
      boxShadow="small"
      borderRadius="standard"
      display="flex"
      flexDirection="column"
      gap="gutter"
      style={{ width: '300px' }}
    >
      <CoverImage />

      <Box display="flex" flexDirection="column" gap="small">
        {loading ? (
          <Skeleton.Text lineCount={1} />
        ) : (
          <Text size="small" weight="medium">
            {t('Public Link')}
          </Text>
        )}
        <PublicLinkField />
      </Box>

      <DetailsButtons />
    </Box>
  )
}
